import React from 'react';
import { roleAllowed } from '../../utils/Utils';

export interface ProtectedElementProps {
  roles?: string[];
  member?: any;
  fallback?: React.ReactNode;
  allow?: boolean;
  children: any;
}

function ProtectedElement({ roles, member, children, fallback, allow }: ProtectedElementProps) {
  let allowed = true;
  if (roles && member) {
    allowed = roleAllowed(roles, member);
  }

  if (allow) {
    allowed = true;
  }
  return (
    <>
      {allowed && children}
      {!allowed && fallback}
    </>
  );
}

export default React.memo(ProtectedElement);
